<div class="dialog">
  <table class="table table-bordered border-primary">
    <thead>
      <tr>
        <th>Sr. No.</th>
        <th>Book Name</th>
        <th>Net Amount</th>
        <th>Book Copies</th>
        <th>Total</th>
        <th>Shipping Charges</th>
        <th>Total Value</th>
        <th>Remaining Amount</th>
        <th>Return Book Copies</th>
        <th>Book Credit Amount</th>
        <th>Shipping Charges</th>
        <th>Total</th>
        <th>Remark</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let book of bookdata; let i = index">
        <td>{{ i + 1 }}</td>
        <td>{{ book.book_name }}</td>
        <td>{{ book.book_price }}</td>
        <td>{{ book.book_copies }}</td>
        <td>{{ book.total }}</td>
        <td>{{ book.shipping_charges }}</td>
        <td>{{ book.total_amount }}</td>
        <td>{{ book.remaining_amt }}</td>

        <!-- Return Copies -->
        <td class="compact-cell">
          <input
            matInput
            type="number"
            [value]="book.return_copies"
            (change)="calculateCopies($event, book)"
            [disabled]="book.isDisabled"
            class="compact-input"
          />
        </td>

        <!-- Credit Amount -->
        <td class="compact-cell">
          <input
            matInput
            type="number"
            [(ngModel)]="book.crdtnote_amt"
            (ngModelChange)="onCreditAmountInput($event, book)"
            class="compact-input"
          />
        </td>

        <!-- Shipping Charges -->
        <td class="compact-cell">
          <input
            matInput
            type="number"
            [(ngModel)]="book.shipping_charges"
            (ngModelChange)="onShippingChargesInput($event, book)"
            class="compact-input"
          />
        </td>

        <!-- Total -->
        <td class="compact-cell1">
          <span class="compact-display1">{{ calculateTotalAmount1(book) }}</span>
        </td>

        <!-- Remark -->
        <td>
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-select
              placeholder="Remark"
              [(ngModel)]="book.remark"
              (ngModelChange)="onRemarkChange($event, book)"
            >
              <!-- ✅ Dynamic options — includes API values like 'TDS रक्कम' -->
              <mat-option *ngFor="let opt of remarkOptions" [value]="opt">
                {{ opt }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </tr>

      <!-- Totals Row -->
      <tr>
        <td colspan="7" style="text-align: right; font-weight: bold;">Totals:</td>
        <td>{{ totalRemainingAmount }}</td>
        <td>{{ totalReturnCopies }}</td>
        <td>{{ totalCreditAmount | number: '1.2-2' }}</td>
        <td>{{ shippingChargesSum | number: '1.2-2' }}</td>
        <td>{{ totalAmount1Sum | number: '1.2-2' }}</td>
        <td></td>
      </tr>
    </tbody>
  </table>
</div>

<!-- <div class="dialog">
  <button
    class="btn btn-primary"
    style="margin-top: 2%; width: 10%"
    mat-button
    (click)="update()"
  >
    Update
  </button>
</div> -->